import { useNavigate, useParams } from "react-router-dom";
import { ReportProvider, useReportContext } from "../providers/ReportProvder"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Accordion from "../components/Accordion";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";


const ApplicationReportDetails = () => {

    return (
        <ReportProvider>
            <Main />
        </ReportProvider>
    )
}

const Main = () => {
    const { t } = useTranslation();
    const { report, reportConfig } = useReportContext();

    const navigate = useNavigate();
    const params = useParams();

    const goBack = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        // navigate(`/soknad/${params.id}/rapporter`)
        navigate(-1)
    }

    if (!report || !reportConfig) return false;

    return (
        <div className="row justify-content-start">
            <div className="col-lg-8">
                <a href="#" className="text-decoration-none" style={{ fontSize: 15 }} onClick={goBack}>
                    <FontAwesomeIcon icon={["far", "chevron-left"]} size="sm" className="me-1" /> {t('report_back_to_overview')}
                </a>

                <div className="mt-2">
                    <h4>{report.type}</h4>
                    <p>{`${t('report_submitted')} ${format(report.archivedon, 'dd.MM.yyyy')} kl. ${format(report.archivedon, 'HH.mm')}`}</p>
                </div>

                <Accordion
                    formData={report.payload}
                    application={reportConfig}
                />
            </div>
        </div>
    )
}

export default ApplicationReportDetails;